module.exports = __webpack_public_path__ + "static/media/SDGIcons_8.fd268c38.png";